import { Field } from '#app/components/form/field.tsx'
import { SelectField } from '#app/components/form/select-field.tsx'

import { SALES_CHANNEL_COPY } from '#app/routes/mocra+/_form+/components/sales-channels/constants.ts'
import { type SalesChannelDraft } from '#app/routes/mocra+/_form+/components/sales-channels/types.ts'
import { RECALL_SALES_CHANNEL_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

type DraftErrors = Partial<Record<keyof SalesChannelDraft, string>>

type Props = {
	readonly formId: string
	readonly draft: SalesChannelDraft
	readonly errors: DraftErrors
	readonly onDraftFieldChange: <Field extends keyof SalesChannelDraft>(
		field: Field,
		value: SalesChannelDraft[Field],
	) => void
	readonly onSubmit: React.FormEventHandler<HTMLFormElement>
}

export function SalesChannelForm({
	formId,
	draft,
	errors,
	onDraftFieldChange,
	onSubmit,
}: Props) {
	return (
		<form id={formId} onSubmit={onSubmit}>
			<SelectField
				labelProps={{ children: SALES_CHANNEL_COPY.fields.typeLabel }}
				selectProps={{
					value: draft.type,
					onChange: (event) =>
						onDraftFieldChange(
							'type',
							event.target.value as SalesChannelDraft['type'],
						),
					onValueChange: (next) =>
						onDraftFieldChange('type', next as SalesChannelDraft['type']),
				}}
				options={RECALL_SALES_CHANNEL_OPTIONS}
			/>
			<Field
				labelProps={{ children: SALES_CHANNEL_COPY.fields.nameLabel }}
				inputProps={{
					value: draft.name,
					onChange: (event) => onDraftFieldChange('name', event.target.value),
					type: 'text',
				}}
				errors={errors.name ? [errors.name] : undefined}
			/>
		</form>
	)
}
